import { Mood } from 'generated/mos/org/getty/audio'
import { TranslatableStringValue, TranslatableMediaValue } from 'generated/mos/translatable'
import { MoodColor } from 'generated/mos/org/getty/color'
import { Schema } from 'helpers/schema'

import {
  createTranslatableStringValue,
  getTranslatableValue,
  setTranslatableValue,
  createTranslatableMediaValue,
} from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length)) {
    return false
  }

  return value
}

export const moodSchema: Schema<Mood.Entity> = {
  name: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  description: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  imageRef: {
    read: value => value as any,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  imageAltText: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  creditText: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  audio: {
    read: (value, language) => getTranslatableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableMediaValue(value as any, language),
      existingValue ?
        existingValue as TranslatableMediaValue.Entity :
        TranslatableMediaValue.defaults,
    ) as any as TranslatableMediaValue.Entity : undefined,
  },
}
